import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircleIcon, TrendingDownIcon, ClockIcon } from 'lucide-react';
export function ProblemSection() {
  const stats = [{
    icon: ClockIcon,
    stat: '82%',
    label: 'of homeowners expect responses within 10 minutes'
  }, {
    icon: TrendingDownIcon,
    stat: '67%',
    label: 'book with the first contractor who responds'
  }, {
    icon: AlertCircleIcon,
    stat: '$3,500',
    label: 'average revenue lost per slow response (landscaping)'
  }];
  return <section className="py-20 px-6 bg-[var(--white-smoke)]" data-id="element-197">
      <div className="max-w-6xl mx-auto" data-id="element-198">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-199">
          <h2 className="text-4xl md:text-5xl font-bold text-[var(--jet-black)] mb-4" data-id="element-200">
            Every Minute Costs You Money
          </h2>
          <p className="text-xl text-[var(--graphite-gray)] max-w-2xl mx-auto" data-id="element-201">
            Homeowners don't wait. They book with whoever responds first—and
            it's usually not you.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-202">
          {stats.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-xl shadow-lg text-center" data-id="element-203">
              <item.icon className="w-12 h-12 text-[var(--viridia-green)] mx-auto mb-4" data-id="element-204" />
              <div className="text-5xl font-bold text-[var(--jet-black)] mb-2" data-id="element-205">
                {item.stat}
              </div>
              <p className="text-[var(--graphite-gray)]" data-id="element-206">{item.label}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}